import TemplateView from '../../../TemplateView'
import messageResource from '../../../messageResource'
import SimpleDiv from '../../../components/SimpleDiv'

export default class LimitedFunctionalityList extends TemplateView {
    constructor() {
        super()

        this.state = {
            unavailableInFreeFeatures: []
        }

        this.onStatePropertyChanged('unavailableInFreeFeatures', () => {
            this.updateListFeatures()
        })
    }

    templateHtml() {
        return '<div class="limitedFunctionalityList">' +
               '    <div class="listHeader"><%=listHeader%></div>' +
               '    <div class="list"/>' +
               '</div>'
    }

    messageKeys() {
        return {
            listHeader: 'licenses.chooser.limited_functionality.list_title',
        }
    }

    afterRender() {
        this.$list = this.find('.list')
        this.updateListFeatures()
    }

    updateListFeatures() {
        this.$list.empty()
        const additionalClass = 'unavailableFeature'
        this.state.unavailableInFreeFeatures.forEach(feature => {
            let text
            if (feature === 'API') {
                text = messageResource.getMessage('licenses.chooser.limited_functionality.API')
                new SimpleDiv({
                    text: messageResource.getMessage('licenses.chooser.limited_functionality.chrome_extension'),
                    additionalClass,
                }).init(this.$list)
            } else {
                text = messageResource.getMessage('features.' + feature + '.title')
            }

            new SimpleDiv({
                text,
                additionalClass,
            }).init(this.$list)
        })
    }
}



// WEBPACK FOOTER //
// ./web/js/administration/licenses/components/LimitedFunctionalityList.js